"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANGSearch = void 0;
const React = __importStar(require("react"));
const ControlledSearch_1 = __importDefault(require("./ControlledSearch"));
class ANGSearch extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClear = (state) => {
            this.props.onClear ? this.props.onClear(state) : this.props.onValueChange(state);
        };
        this.handleClearAllFilters = (state) => {
            this.props.onClearAllFilters ? this.props.onClearAllFilters(state) : this.props.onValueChange(state);
        };
        this.handleApply = (state) => {
            const { config, executor } = this.props;
            executor(config, state);
        };
    }
    export() {
        return this.props.value;
    }
    search() {
        this.handleApply(this.props.value);
    }
    render() {
        const { placeholder, value, config, customFilters, customComponents, onValueChange, showFreeText, showClearAllFilters, applyOnClear, } = this.props;
        return (React.createElement(ControlledSearch_1.default, { placeholder: placeholder || 'Search', value: value, config: config, onChange: onValueChange, customFilters: customFilters, customComponents: customComponents, onApply: this.handleApply, onClear: this.handleClear, onClearAllFilters: this.handleClearAllFilters, showFreeText: showFreeText, showClearAllFilters: showClearAllFilters, applyOnClear: applyOnClear }));
    }
}
exports.ANGSearch = ANGSearch;
exports.default = ANGSearch;
